import { render } from "./DrawingCloudPanel.vue?vue&type=template&id=dc5b44e2"
import script from "./DrawingCloudPanel.vue?vue&type=script&lang=js"
export * from "./DrawingCloudPanel.vue?vue&type=script&lang=js"

import "./DrawingCloudPanel.vue?vue&type=style&index=0&id=dc5b44e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__